import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * RegisterPage ya no se usa.
 * Ahora usamos email-first flow en LoginPage (como Gmail/Slack).
 * Este componente redirige a /login.
 */
const RegisterPage: React.FC = () => {
  return <Navigate to="/login" replace />;
};

export default RegisterPage;